var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":this.$store.getters.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){return _vm.$set(this.$store.getters, "isLoading", $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }